import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createPoliciesFailed, createPoliciesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { normalizePolicyPayload } from '../../../dto/PoliciesDTO';

export default function* createPolicies(action) {
  try {
    const url = `${BACKEND_URL}/policies`;
    const pool = normalizePolicyPayload(action.payload);
    delete pool.policy_id;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createPoliciesSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createPoliciesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createPoliciesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
